import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import type { ConversationItem } from '@chatapp-inbox/shared';
import { getConversation } from '../../api';
import { conversationKey } from './keys';

/**
 * A conversa aberta (contato, responsável, `canWrite`). Quem muda a conversa (atribuir, marcar
 * como lida) atualiza este cache com `syncConversation`, e a T26 fará o mesmo com eventos.
 */
export function useConversation(id: string): UseQueryResult<ConversationItem> {
  return useQuery({
    queryKey: conversationKey(id),
    queryFn: ({ signal }) => getConversation(id, signal),
  });
}
